var version = {
    "name":      "dativery",
    "buildDateCode": "20260717-160524",
    "buildDate": "Fri Jul 17 2026 16:05:24 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260717-160524",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;